export const isErrorContent = (content) => {
  // if (!content || content.trim().length < 50) {
  //   return true;
  // }
  const errorPatterns = [
    /i'?m sorry/i,
    /i can'?t provide/i,
    /i cannot provide/i,
    /unable to generate/i,
    /failed to generate/i,
    /error generating/i,
    /something went wrong/i,
    /try again/i,
    /no te puedo ayudar/i,
    /no puedo ayudar con eso/i,
    /lo siento.*no puedo/i,
  ];
  
  const contentLower = content.toLowerCase();
  return errorPatterns.some(pattern => pattern.test(contentLower));
};

export const filterValidStories = (stories) => {
  if (!Array.isArray(stories)) return [];
  return stories.filter(item => !isErrorContent(item?.story_content || ''));
};

